<template>
  <div>
    <div class="row" v-for="(article, index) in articles" :key="index">
        <div class="col-md-12 ml-auto mr-auto">
          <base-button simple block type="warning" v-on:click="showRows('item_' + index)">{{article.name}}</base-button>
        </div>
        <div class="col-md-12 ml-auto mr-auto">
          <blockquote class="blockquote" :class="'item_' + index" style="display: none; border-radius: 10px;">
            <div class="row">
              <base-input class="col-lg-4 col-md-3"
                          label="Name of item"
                          v-model="article.name"
                          placeholder="item-name">
              </base-input>
              <base-input class="col-lg-4 col-md-3"
                          label="Description"
                          v-model="article.description"
                          placeholder="item-description">
              </base-input>
              <base-input v-if="projectId === '3'" class="col-lg-2 col-md-3"
                          label="Order"
                          v-model="article.office_order"
                          type="number"
                          placeholder="office-order">
              </base-input>
              <base-input v-else class="col-lg-2 col-md-3"
                          label="Order"
                          v-model="article.others_order"
                          type="number"
                          placeholder="others-order">
              </base-input>
              <base-input class="col-lg-2 col-md-3 col-6" label="Effect">
                <base-radio name="False" class="mb-3" v-model="article.is_expense">
                  Income
                </base-radio>
                <base-radio name="True" class="mb-3" v-model="article.is_expense">
                  Expense
                </base-radio>
              </base-input>
            </div>
          </blockquote>
        </div>
    </div>
  </div>
</template>

<script>
    import {showElement} from "../../plugins/axios";

    export default {
      name: "existing-articles",
      props:['articles', 'projectId'],
      data(){
        return{

        }
      },
      methods:{
        showRows(className){showElement(className)}
      },
    }
</script>

<style scoped>

</style>
